import { ProductType } from '../../types';
import {
  getDiscountPercentage,
  setSpaceBetweenDigits,
} from '../../utils/utils';

type CardProps = {
  product: ProductType;
};

export default function Card({ product }: CardProps): JSX.Element | null {
  const {
    brandId,
    nameTranslit,
    productId,
    name,
    image,
    status: { soldOut },
    price: { basePrice, salePrice },
  } = product;

  const logoPath = `https://static.mvideo.ru/pics/brands/${brandId}.gif`;
  const productPath = `https://www.mvideo.ru/products/${nameTranslit}-${productId}`;
  const productImage = `https://img.mvideo.ru/${image}`;

  return !soldOut ? (
    <div className="swiper-slide">
      <div className="m-card">
        <div className="m-card__wrapper">
          <div className="m-card__top">
            {basePrice !== salePrice ? (
              <div>
                <p className="m-card__label">
                  <span>
                    {`Скидка ${getDiscountPercentage(basePrice, salePrice)}`}
                  </span>
                </p>
              </div>
            ) : (
              <div>
                <p className="m-card__label">
                  <span></span>
                </p>
              </div>
            )}
            <div className="m-card__logo m-card__logo--80">
              <img src={logoPath} loading="lazy" alt="" />
            </div>
          </div>
          <a href={productPath} className="m-card__image">
            <img
              src={productImage}
              loading="lazy"
              className="m-card__img"
              alt=""
            />
          </a>
          <div className="m-card__description">
            <a href={productPath} className="m-card__name">
              {name}
            </a>
          </div>
          <div className="m-card__bottom">
            <div className="m-card__price m-price">
              {basePrice && (
                <div
                  className={`m-price__old ${
                    basePrice === salePrice ? '_op0' : ''
                  }`}
                >
                  {setSpaceBetweenDigits(basePrice)} ₽
                </div>
              )}
              {salePrice && (
                <div className="m-price__new">
                  {setSpaceBetweenDigits(salePrice)} ₽
                </div>
              )}
            </div>
            <div className="m-card__btn">
              <a href={productPath} className="m-card__more m-btn">
                Подробнее
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

// import { ProductType } from '../../types';
// import {
//   getDiscountPercentage,
//   setSpaceBetweenDigits,
// } from '../../utils/utils';

// type CardProps = {
//   product: ProductType;
// };

// export default function Card({ product }: CardProps): JSX.Element | null {
//   const {
//     brandId,
//     nameTranslit,
//     productId,
//     name,
//     image,
//     status: { soldOut },
//     price: { basePrice, salePrice },
//   } = product;

//   const logoPath = `https://static.mvideo.ru/pics/brands/${brandId}.gif`;
//   const productPath = `https://www.mvideo.ru/products/${nameTranslit}-${productId}`;
//   const productImage = `https://img.mvideo.ru/${image}`;

//   return !soldOut ? (
//     <div className="swiper-slide">
//       <div className="m-card">
//         <div className="m-card__container">
//           <div className="m-card__header header-card">
//             {basePrice !== salePrice ? (
//               <p className="header-card__label">
//                 {`Скидка ${getDiscountPercentage(basePrice, salePrice)}`}
//               </p>
//             ) : (
//               <p className="header-card__label _op0"></p>
//             )}
//             <div className="header-card__logo">
//               <img src={logoPath} loading="lazy" alt="" />
//             </div>
//           </div>
//           <a href={productPath} className="m-card__img">
//             <img src={productImage} loading="lazy" alt="" />
//           </a>
//           <div className="m-card__name">
//             <a href={productPath}>{name}</a>
//           </div>
//           <div className="m-card__footer footer-card">
//             <div className="footer-card__prices">
//               {basePrice && (
//                 <div
//                   className={`footer-card__old-price ${
//                     basePrice === salePrice ? '_op0' : ''
//                   }`}
//                 >
//                   {setSpaceBetweenDigits(basePrice)} ₽
//                 </div>
//               )}
//               {salePrice && (
//                 <div className="footer-card__new-price">
//                   {setSpaceBetweenDigits(salePrice)} ₽
//                 </div>
//               )}
//             </div>
//             <a href={productPath} className="footer-card__link">
//               <span>Подробнее</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   ) : null;
// }
